import { get_config } from '@/config'

const config = get_config()

type HeadOptions = {
  title?: string
}
export function setHead({ title }: HeadOptions) {
  if (document) {
    document.title = `${title ? `${title} | ` : ''}${config.app_name} - ${config.app_version}`
  }
}
